// When running in browser on production domain (e.g. clinicerp.tcwebstudio.com or clinicerp.jeevanrekhaayurved.com),
// use the matching production backend API. On localhost, use the local development backend.
const isBrowser = typeof window !== 'undefined';
const isLocalhost = isBrowser && (
  window.location.hostname === 'localhost' ||
  window.location.hostname === '127.0.0.1'
);

function getApiUrl(): string {
  if (isLocalhost) {
    return 'http://localhost:8000/api';
  }
  if (isBrowser && window.location.hostname.includes('tcwebstudio.com')) {
    return 'https://clinicerpapi.tcwebstudio.com/api';
  }
  return 'https://clinicerp-api.jeevanrekhaayurved.com/api';
}

export const environment = {
  production: !isLocalhost,
  apiUrl: getApiUrl(),
};
